import React, { useEffect, useState,useContext, useRef } from "react";
import { AppContext, UserContext } from "../../AppContextProvider";
import Popup from "reactjs-popup";
import { BrowserView,isMobile, MobileView } from "react-device-detect";
import {ButtonLoader} from "../utils/ButtonLoader";
import { useFetch } from "../api/FetchApiData";
import { MediaUrl } from "../utils/Media";
import Select from "react-select";
import default_bg from './icons/default_bg.png';
import remove_icon from '../icons/remove.png';
import add_icon from './icons/add.png';


if (isMobile)
    import('./m_une.css').then(() => {});
else
    import('./une.css').then(() => {});



const SettingsPopUp = ({Une = {title:'',description:'',image:null,articles:[]}})=>
{
    const [loading,setLoading] = useState(false);
    const [une, setUne] = useState(Une);
    const [img,setImg] = useState(Une.image);
    const [meta,setMeta] = useState([]);
    const [articles,setArticles] = useState([]);
    const [DefaultSelectedArticles,setDefaultSelectedArticles] = useState([]);
    const [categories,setCategories] = useState([]);
    const fetchData = useFetch();
    const [notif,setNotif] = useState({text:"",color:"black"});
    const [UserState, setUserState] = useContext(UserContext);

    const saveUne = (close)=>
    {
        setLoading(true);
        let _une = une;
        if(!_une.hasOwnProperty('id'))
        {
            let formdata = new FormData();
            formdata.append('image',_une.image,_une.image.name);
            delete _une.image;
            formdata.append('data',JSON.stringify(_une));
            fetchData.PostFormData(formdata,'une/').then((result)=>{
                if(result.result)
                {
                    setLoading(false);
                    setNotif({text:"Une ajouter avec succès ...",color:"green"});
                    setTimeout(()=>{setNotif({text:"",color:'black'});close();})
                }
                else
                {
                    setLoading(false);
                    setNotif({text:"Une erreur s'est produite. Votre demande n'a pas pu être executé.",color:"orangered"});
                }
            })

        }
    }

    const updateArticles = (_articles)=>{
        
        const FormatArticle = (art)=>
        {
            return(
                <div style={{textAlign:'left',paddingLeft:'10px'}}>
                    <img src={MediaUrl(art.image)} style={{verticalAlign:'middle',width:'40px',height:'40px',borderRadius:'20px',display:'inline-block'}} />
                    <div style={{marginLeft:'20px',verticalAlign:'middle',display:'inline-block'}}>
                        <h5 style={{margin:'2px'}}>{art.title}</h5>
                        <span style={{color:'gray'}}>Reference : {art.id}</span>
                    </div>
                </div>
            );
        }
        let arr = [];
        let defaults = [];
        _articles.forEach(art=>{
            arr.push({label:FormatArticle(art),value:art.id});
            if(une.articles.includes(art.id))
                defaults.push({label:FormatArticle(art),value:art.id});
        
        });
        setArticles(arr);
        setDefaultSelectedArticles(defaults);
    }

    useEffect(()=>{
        if(!UserState.auth)
        {
            navigator('/')
        }
    },[UserState.auth])

    useEffect(()=>{
        var params = new URLSearchParams({
            meta:true
        });

        fetchData.GetData(`meta/articles/?${params}`).then((result)=>{
            if(result.result && result.meta.length > 0)
            {
                setMeta(result.meta);
                setCategories(Object.values(result.meta[0])[0]);
                updateArticles(result.articles);
            }
        });
    },[])

    const HandleSelectCategory = async (value)=>
    {    
        var params = new URLSearchParams({
            category:value
        })
        fetchData.GetData(`meta/articles/?${params}`).then((result)=>{
            console.log(result);
            if(result.result)
            {
                updateArticles(result.articles);
            }
        })
        
    }

    const HandleSelectArticle = (value, SelectedItems)=>{
        if(!!SelectedItems)
        {
            let arr = [];
            SelectedItems.forEach((item)=>{
                if(articles.includes(item))
                {
                    arr.push(item.value);
                }
            });
            setUne({...une,articles:arr});
        }
    } 

    return(
        <Popup trigger={<img src={add_icon} className="UneTrigger"/>}>
            {close=>(<div id="AddUne">
                <fieldset>
                    <p style={{color:notif.color}}>{notif.text}</p>
                    <div className="line">
                        <label className="une-label">Titre : </label>
                        <input className="une-input" onChange={(e)=>{setUne({...une,title:e.target.value});}} type="text" placeholder="titre" />
                    </div>
                    <div className="line">
                        <label className="une-label">Description : </label>
                        <textarea className="une-input" style={{height:'60px'}} onChange={(e)=>{setUne({...une,description:e.target.value});}} placeholder="Descriptif" />
                    </div>
                    <div className="line">
                        <label className="une-label">Articles : </label>
                        <div className="une-div-input" style={{padding:'5px',border:'1px solid lightgray'}}>
                            <div style={{width:'100%'}}>
                                <div className="une-div-input">
                                    <label className="une-div-label" >Rayons :</label>
                                    <select className="une-input"  onChange={e=>{
                                            console.log(meta,e.target.value);
                                            const cat = meta.find(m=>m.hasOwnProperty(e.target.value));
                                            if (!!cat)
                                                setCategories(cat[e.target.value]);
                                            else 
                                                setCategories([]);
                                        }}>  
                                        {meta.map((m)=>{
                                            return(Object.keys(m).map(key=>(<option key={key}>{key}</option>)));
                                        })}
                                    </select>
                                </div>
                                <div className="une-div-input">
                                    <label className="une-div-label">Categories :</label>
                                    <select className="une-input" onChange={e=>{HandleSelectCategory(e.target.value)}}>
                                        {categories.map(cat=>{
                                            return(Object.keys(cat).map(key=>(<option key={key} value={cat[key]}>{key}</option>)))
                                        })}
                                    </select>
                                </div>
                                <div className="une-div-input">
                                    <label className="une-div-label">Articles :</label>
                                    <div className="une-input">
                                        <Select isClearable={true} isSearchable={true} defaultValue={DefaultSelectedArticles} onChange={(value,action)=>{HandleSelectArticle(action,value)}} loading={false} isMulti={true} options={articles} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="line" style={{minHeight:'40px'}}>
                        <label className="une-label">Image : </label>
                        <input className="une-input" accept="image/png,image/jpeg,image/jpg" type='file' onChange={(e)=>{une.image = e.target.files[0]; setImg(URL.createObjectURL(une.image));}}/>
                    </div>
                    <div className="line" style={{textAlign:'center'}}>
                        <img style={{width:'30%'}} src={img} />
                    </div>
                    <div className="line" style={{textAlign:'center'}}>
                        <div style={{borderRadius:'5px',border:'none',padding:'10px 20px 10px 20px',width:'fit-content',backgroundColor:'lightgreen',display:'inline-block'}}>
                            <ButtonLoader loading={loading} style={{backGroundColor:'lightgreen'}} onSubmit={(e)=>{saveUne(()=>{close()});}} text={'Enregistrer'} />
                        </div>
                        <input type="button" onClick={close} value={'Annuler'} style={{border:'none',padding:'10px 20px 10px 20px',width:'fit-content',margin:'5px',backgroundColor:'orangered',borderRadius:'5px',display:'inline-block'}} />
                    </div>
                </fieldset>
            </div>)}
        </Popup>
    );
}


export default function Une(props)
{
    const [TimerIsCanceled,SetisCanceled] = useState(false);
    const [limitDescrip,setLimitDescrip] = useState(270);
    const [AppState,setAppState] = useContext(AppContext);
    const [UserState,setUserState] = useContext(UserContext);
    const [items,setitems] = useState([]);
    const fetchData = useFetch();
    let UneIndex = useRef(0);
    const [Une,setUne] = useState({
            image:{image:default_bg},
            is_default:true,
            color:'black',
            title: "Aucun page en Une n'est disponible en ce moment",
            description:"Vous pouvez en ajouter une en appuyant sur le button Ajouter (+). Donnez un titre à votre page, Ajouter une description puis choisir une image ...",
        });
    const [Bg,setBg] = useState(default_bg);

    useEffect(()=>{
        const params = new URLSearchParams({une:'all'})
        if(isMobile)
            setLimitDescrip(100);
        fetchData.GetData(`une/?${params}`).then((result)=>{
            if(result.result && result.unes.length>0)
            {
                setitems(result.unes);
                setUne(result.unes[0]);
            }
        })

    },[])

    useEffect(()=>{
        const UneTimer  = setInterval(()=>{
            if(items.length>0)
            {
                UneIndex.current++;
                setUne(items[UneIndex.current % items.length]);
            }},30000);
        return ()=>{clearInterval(UneTimer)};
    })

    useEffect(()=>{
        if((!!Une.is_default && Une.is_default))
            setBg(default_bg);
        else
            setBg(MediaUrl(Une.image.image));
    },[Une])

    const SettingsTrigger = ()=>
    {
        let _settings = '';
        if(UserState.is_staff)
            _settings = <><SettingsPopUp /><img src={remove_icon} className="UneTrigger"/></>;
        if(!isMobile || UserState.is_staff)
        {
            return(               
                <div id="InfoUne" style={{textAlign:'left'}}>
                    <BrowserView>
                        <div className="InfoText">
                            <h3 style={{color:'black',marginTop:'0px'}} id="Title">{Une.title} </h3>
                            <p style={{color:'black',maxWidth:'90%',textOverflow:'ellipsis',paddingTop:'5px'}} id="Text">{Une.description.substring(0,limitDescrip)}</p>
                        </div>
                    </BrowserView>
                    <div className="Controls" >
                        {_settings}
                    </div>
                </div>
            );
        }
    }

    if(items.length > 0 || UserState.is_staff)
    {
        return(
            <div id="Une" style={{textAlign:'center',backgroundImage:"url("+Bg+")"}}>
                {SettingsTrigger()}
                <div className="btn-une-switch">
                    {
                        items.map((item,index)=>{
                        let size = '15px'
                        let border = 'none';
                        if(item===Une)
                        {border = '1px solid black';size='14px';}         
                        return(<img key={index} onClick={e=>{setUne(item);}} src={MediaUrl(item.image.image)} className="UneIcon" style={{border:border,width:size,height:size}}/>)})
                    }
                </div>
        </div>
        );
    }
    
}